<!-- https://8es9hr.axshare.com/#g=1&p=%E6%96%B0%E5%A2%9E%E5%B9%B4%E5%BA%A6%E9%A0%90%E7%AE%97 -->
<!-- 新增年度預算 -->
<template>
  <div style="display: flex">
    <Step :workflow="workflow" @goForm="goForm"></Step>
    <div class="bgf" :class="{ 'step-form': true, w100p: false }">
      <!-- 設定各科目年度預算 -->
      <div>
        <ListForm
          api="CoopYearBudgetDetail"
          :id="id"
          labelPosition="top"
          formTitle="設定各科目年度預算"
          :rules="rules"
          :recordToEdit="recordToEdit"
          :formType="formType[0]"
          v-show="titleLabel == '設定各科目年度預算'"
        >
          <div slot="form">
            <workbench
              :columns="columns"
              :toolbar="toolbar"
              @editData="editData"
              @addData="editData"
              :changeDelete="changeDelete"
              @deleteData="remove"
              :paganationShow="false"
              @dataChangeEvent="dataFilterChange"
              ref="workbench"
            >
            </workbench>
          </div>
          <div class="dialog-footer" slot="footer">
            <el-button
              type="primary"
              @click="submit"
              v-if="recordToEdit.isSubmit == 0 || !recordToEdit.isSubmit"
              >送出</el-button
            >
            <el-button @click="back">返回</el-button>
          </div>
        </ListForm>
      </div>
      <!-- 主任審查 -->
      <ListForm
        api=""
        :id="id"
        labelPosition="top"
        formTitle="主任審查"
        :recordToEdit="reviewData"
        :formType="formType[1]"
        v-show="titleLabel == '主任審查'"
      >
        <div slot="footer" class="dialog-footer">
          <el-button @click="back">返回</el-button>
        </div>
      </ListForm>
      <!-- 經理審查 -->
      <ListForm
        api=""
        :id="id"
        labelPosition="top"
        formTitle="經理審查"
        :recordToEdit="reviewData"
        :formType="formType[1]"
        v-show="titleLabel == '經理審查'"
      >
        <div slot="footer" class="dialog-footer">
          <el-button @click="back">返回</el-button>
        </div>
      </ListForm>
      <!-- 理事會審查 -->
      <ListForm
        api=""
        :id="id"
        labelPosition="top"
        formTitle="理事會審查"
        :recordToEdit="reviewData"
        :formType="formType[1]"
        v-show="titleLabel == '理事會審查'"
      >
        <div slot="footer" class="dialog-footer">
          <el-button @click="back">返回</el-button>
        </div>
      </ListForm>
      <!-- 匯出報表 -->
      <!-- <div v-if="workflow[3].statusKey == 1"
                 class="col-block">
                <div class="block-header has-border">
                    <h3><strong>匯出報表</strong></h3>
                </div>
                <div class="block-content">
                    送審日期 : 2018-01-03 12:00 <br>
                    審查日期 :<br>
                    審查結果 : 審查中<br>
                    備註 : 無<br>
                </div>
            </div> -->
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogListForm"
      :modal-append-to-body="false"
      :append-to-body="true"
      @close="closeGetData"
    >
      <el-form label-position="top">
        <el-form-item label="會計科目">
          <el-select
            class="el-select"
            v-model="editItem.accountTitleId"
            placeholder="請選擇"
            filterable
            :disabled="isDialogReadOnlySubmitted"
          >
            <el-option
              v-for="item in accountTitleList"
              :value="item.value"
              :label="item.label"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金額">
          <el-input
            v-model="editItem.amount"
            v-on:input="resetAmount(editItem.amount)"
            :disabled="isDialogReadOnlySubmitted"
          ></el-input>
        </el-form-item>
        <el-form-item label="備註">
          <el-input
            type="textarea"
            v-model="editItem.note"
            :disabled="isDialogReadOnlySubmitted"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          v-if="showDialogConfirmButton"
          @click="addItem"
          >確定</el-button
        >
        <el-button @click="dialogListForm = false">{{
          isDialogReadOnlySubmitted ? "關閉" : "取消"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Step from "@/components/Step.vue";
import { API } from "@/assets/config";
import ListForm from "@/components/ListForm.vue";
import Workbench from "@/components/Workbench";
export default {
  name: "annual_budget_edit",
  components: { Step, ListForm, Workbench },
  data() {
    return {
      id: this.$route.params.id,
      editId: "",
      mode: "",
      dialogListForm: false,
      changeDelete: true,
      first: true,
      reviewTitleLabel: this.$route.query.titleLabel,
      titleLabel: "設定各科目年度預算",
      editItem: {
        accountTitleName: "",
        accountTitleCode: "",
        accountTitleId: "",
        coopYearBudgetId: "",
        amount: "",
        note: "",
      },
      // 暫時寫死for demo
      workflow: [],
      recordToEdit: {
        year: "",
      },
      reviewData: {},
      accountTitleList: [],
      currentEdit: {},
      rules: {},
      toolbar: {
        editable: true,
        removeable: true,
        addable: true,
      },
      formType: [
        [
          {
            label: "年度",
            key: "year",
            type: "select",
            options: [],
            vif: false,
          },
          {
            label: "年度",
            key: "year",
            type: "input",
            vif: false,
            disabled: true,
          },
          {
            slot: "form",
            type: "slot",
          },
        ],
        [
          {
            label: "送審日期",
            key: "sendTime",
            type: "date",
            disabled: true,
          },
          {
            label: "審查日期",
            key: "reviewTime",
            type: "date",
            disabled: true,
          },
          {
            label: "審查結果",
            key: "statusKey",
            type: "radio",
            disabled: true,
            options: [
              {
                label: "審查中",
                value: 1,
              },
              {
                label: "通過",
                value: 2,
              },
              {
                label: "不通過",
                value: 3,
              },
            ],
          },
          {
            label: "備註",
            key: "",
            type: "input",
            disabled: true,
          },
        ],
      ],
      columns: [
        {
          label: "科目代號",
          prop: "accountTitleCode",
        },
        {
          label: "科目名稱",
          prop: "accountTitleName",
        },
        {
          label: "科目金額",
          prop: "amount",
          addcomma: true,
        },
        {
          label: "備註",
          prop: "note",
        },
        {
          prop: "updateTime",
          label: "最後修改",
        },
        {
          prop: "updateUserName",
          label: "最後修改人員",
        },
      ],
      allWorkbenchData: [],
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  computed: {
    // 已送出後：列表僅能檢視，編輯視窗不顯示確定、欄位唯讀
    isDialogReadOnlySubmitted() {
      return (
        this.recordToEdit.isSubmit == 1 && this.mode === "edit"
      );
    },
    showDialogConfirmButton() {
      return !this.isDialogReadOnlySubmitted;
    },
    dialogTitle() {
      return this.isDialogReadOnlySubmitted
        ? "檢視會計科目"
        : "新增會計科目";
    },
  },
  watch: {
    recordToEdit: {
      handler(key) {
        if (key.isSubmit == 1) {
          this.toolbar = {
            editable: true,
            removeable: false,
            addable: false,
            select: false,
          };
        } else {
          this.toolbar = {
            editable: true,
            removeable: true,
            addable: true,
            select: true,
          };
        }
      },
    },
    titleLabel() {
      this.workflow.some((item) => {
        if (this.titleLabel == item.label) {
          if (item.reviewInfo) {
            this.reviewData = item.reviewInfo;
          }
        }
      });
    },
    "reviewData.reviewTime": {
      handler(key) {
        if (key) {
          $(`.reviewTime`).val();
        } else {
          $(`.reviewTime`).val("");
        }
      },
    },
    "reviewData.sendTime": {
      handler(key) {
        if (key) {
          $(`.sendTime`).val();
        } else {
          $(`.sendTime`).val("");
        }
      },
    },
    "editItem.accountTitleId": {
      handler(key) {
        this.accountTitleList.filter((item) => {
          if (item.id == key) {
            this.editItem.accountTitleCode = item.code;
          }
        });
      },
      deep: true
    },
  },
  methods: {
    dataFilterChange(data, setting) {
      let whereKeys = Object.keys(setting.params.where);
      let result = this.allWorkbenchData;
      let accountTitleList = this.accountTitleList;
      if (whereKeys.includes("search")) {
        let searchValue = setting.params.where["search"];
        result = result.filter((item) => {
          for (let i = 0; i < this.columns.length; i++) {
            let columnProp = this.columns[i].prop;

            if (
              item[columnProp] !== null &&
              String(item[columnProp]).includes(searchValue)
            ) {
              return true;
            }
          }
          return false;
        });
      }

      if (
        whereKeys.includes("sort") &&
        setting.params.where["sort"].length > 0
      ) {
        let sortKey = Object.keys(setting.params.where["sort"][0])[0];
        let sortValue = setting.params.where["sort"][0][sortKey];

        result = result.sort(function (a, b) {
          let strSortValueA = Number.isInteger(a[sortKey])
            ? a[sortKey]
            : String(a[sortKey]);
          let strSortValueB = Number.isInteger(b[sortKey])
            ? b[sortKey]
            : String(b[sortKey]);

          if (sortKey === "accountTitleId") {
            strSortValueA = accountTitleList.filter(
              (item) => item.id == strSortValueA
            )[0].name;
            strSortValueB = accountTitleList.filter(
              (item) => item.id == strSortValueB
            )[0].name;
          }

          if (
            (sortValue == 0 && strSortValueA < strSortValueB) ||
            (sortValue == 1 && strSortValueA > strSortValueB)
          ) {
            return -1;
          }

          if (
            (sortValue == 0 && strSortValueA > strSortValueB) ||
            (sortValue == 1 && strSortValueA < strSortValueB)
          ) {
            return 1;
          }
          return 0;
        });
      }

      this.$refs.workbench.originData = result;
      this.$refs.workbench.paginationInfo.totalCount = result.length;
    },
    getData() {
      const url = API.CoopYearBudget + `?id=${this.id == "new" ? 0 : this.id}`;
      const thenCB = (json) => {
        this.recordToEdit = Object.assign(
          {},
          this.recordToEdit,
          json.resultData.data.main
        );
        if (this.id !== "new") {
          this.allWorkbenchData = json.resultData.data.detail;
          this.$refs.workbench.isDataWithoutApi = true;
          this.$refs.workbench.originData = json.resultData.data.detail;
          this.$refs.workbench.enumData = json.resultData.enumData;
          this.$refs.workbench.paginationInfo.totalCount =
            this.$refs.workbench.originData.length;
          this.formType[0][1].vif = true;
          this.formType[0][0].vif = false;
          this.recordToEdit.year = this.recordToEdit.year - 1911;
        } else {
          this.formType[0][0].vif = true;
          this.formType[0][1].vif = false;
        }
        this.workflow = json.resultData.workflow;
        this.accountTitleList = json.resultData.enumData.accountTitle.map(
          (item) => {
            return {
              label: `${item.code} ${item.name}`,
              value: item.id,
              ...item,
            };
          }
        );
        this.formType[0][0].options = Object.keys(
          json.resultData.enumData.yearList
        ).map((item) => {
          return {
            label: json.resultData.enumData.yearList[item] - 1911,
            value: Number(json.resultData.enumData.yearList[item]),
          };
        });
        if (this.first) {
          this.workflow.some((item) => {
            if (item.status == 1 && !this.reviewTitleLabel) {
              this.titleLabel = item.label;
              this.first = false;
              if (item.reviewInfo) {
                this.reviewData = item.reviewInfo;
              }
            } else {
              this.titleLabel = this.reviewTitleLabel;
            }
          });
        }
      };
      this.mAxiosGet(url, thenCB);
    },
    resetAmount(amount) {
      return (this.editItem.amount = this.$addcomma(this.$removeComma(amount)));
    },
    addItem() {
      let url = API.CoopYearBudgetDetail;
      const form = new FormData();

      if (this.mode == "edit") {
        url += `?action=update`;
        form.append("id", this.editItem.id || "");
      } else {
        url += `?action=append`;
      }
      if (this.id !== "new") {
        form.append("coopYearBudgetId", this.id);
        form.append("year", this.recordToEdit.year + 1911 || "");
      } else if (this.id == "new" && !this.coopYearBudgetId) {
        form.append("coopYearBudgetId", 0);
        form.append("year", this.recordToEdit.year || "");
      }
      // form.append("id", 0);
      form.append("accountTitleCode", this.editItem.accountTitleCode || "");
      form.append("accountTitleId", this.editItem.accountTitleId || "");
      form.append(
        "amount",
        this.editItem.amount.toString().replace(/,/g, "") || ""
      );
      form.append("note", this.editItem.note || "");

      let thenCB = (json) => {
        this.coopYearBudgetId = json.resultData.coopYearBudgetId;
        this.id = json.resultData.coopYearBudgetId;
        this.showAjaxSuccessMsg();
        this.$router.push({
          name: "annual_budget_edit",
          params: { id: json.resultData.coopYearBudgetId },
        });
        this.getData();
        this.dialogListForm = false;
      };
      this.mAxiosPost(url, form, thenCB);
    },
    submit() {
      try {
        this.beforeSubmit();
      } catch (error) {
        this.$message.error(error.message);
        return;
      }
      const url = API.CoopYearBudget + `?action=submit`;
      const form = new FormData();
      form.append("id", this.id);
      let thenCB = (json) => {
        this.getData();
        this.showAjaxSuccessMsg();
      };
      this.mAxiosPost(url, form, thenCB);
    },
    beforeSubmit() {
      if (this.id == "new") {
        this.$message.closeAll();
        throw new Error("請先新增項目");
      }
    },
    editData(id, row) {
      this.editItem = {};
      if (id == "new") {
        this.mode = "append";
        // let url = API.coopAccountTitle + `?page={limit:9999}`;
        // const thenCB = json => {
        //     this.accountTitleList = json.resultData.data.map(item => {
        //         return {
        //             label: `${item.code} ${item.name}`,
        //             value: item.id,
        //             ...item
        //         };
        //     });
        // };
        // this.mAxiosGet(url, thenCB);
        this.dialogListForm = true;
      } else {
        let newobj = {
          ...row,
          amount: this.$addcomma(row.amount),
        };
        this.mode = "edit";
        this.editItem = newobj;
        this.dialogListForm = true;
      }
    },
    closeGetData() {
      if (this.mode == "edit") {
        this.dialogListForm = false;
        this.getData();
      } else {
        this.dialogListForm = false;
      }
    },
    goForm(item) {
      this.titleLabel = item.label;
    },
    remove(idArray) {
      let url = API.CoopYearBudgetDetail;
      this.$http
        .delete(url, {
          params: {
            action: "remove",
            select: {
              FieldName: "id",
              IsAllSelect: false,
              MemberSelectJson: JSON.stringify(idArray),
            },
          },
        })
        .then(
          (res) => {
            this.$refs.workbench.multipleSelection = [];
            this.$message.closeAll();
            this.$message({
              type: "success",
              message: "刪除成功",
            });
          },
          (error) => {
            this.showAjaxErrorMsg(error);
          }
        );
      this.getData();
    },
    back() {
      this.$router.push({
        name: "annual_budget",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.block-content {
  line-height: 34px;

  table {
    td {
      padding: 4px;
    }
  }

  .box-card {
    margin-top: 10px;
  }
}
.workbench ::v-deep {
  .search-input {
    margin: 0 10px 0;
  }
}
</style>